
export default {
  methods: {
    preventDefault(e) {
      e = e || window.event;
      if (e.preventDefault)
        e.preventDefault();
      e.returnValue = false;  
    }
  }
}



// WEBPACK FOOTER //
// ./components/mixins/PreventDefault.vue